var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wallet"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M6 10V35.75C6 39.2018 8.79822 42 12.25 42H36.75C40.2018 42 43 39.2018 43 35.75V18.25C43 15.2263 40.8528 12.7041 38 12.125V10.25C38 7.90279 36.0972 6 33.75 6H10.25C7.98671 6 6.13664 7.76916 6.00723 10H6ZM35.5 10.25V12H10.25C9.2835 12 8.5 11.2165 8.5 10.25C8.5 9.2835 9.2835 8.5 10.25 8.5H33.75C34.7165 8.5 35.5 9.2835 35.5 10.25ZM32.25 26H36.75C37.4404 26 38 26.5596 38 27.25C38 27.9404 37.4404 28.5 36.75 28.5H32.25C31.5596 28.5 31 27.9404 31 27.25C31 26.5596 31.5596 26 32.25 26Z",
    fill: "#FBFBFB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/WalletIcon.d1ce250e748552952a0858a5aeb8036e.svg";
export { ForwardRef as ReactComponent };